var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.reviewExamen),function(s){return _c('div',{key:s.uid,staticClass:"row"},[_c('div',{staticClass:"col-12 e-c-section"},[_c('h5',[_vm._v(" "+_vm._s(s.libelle))]),_vm._l((s.questions),function(q){return _c('div',{key:q.uid,staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('answer',{attrs:{"question":q}})],1)])})],2)])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }